import React, {useContext, useEffect, useState} from "react";
import {FormHelperText, InputLabel} from "@material-ui/core";
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import { get } from "@api/segment"
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from "@mui/material/Typography/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import OutlinedInput from "@mui/material/OutlinedInput/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import EllipsisText from "react-ellipsis-text";
import {EMPTY_SEGMENT} from "../../../constants";

const useStyles = makeStyles({
    body: {
        padding: '5px 0',
        position: 'relative'
    },
    root:{
        display: 'flex',
        justifyContent: 'space-between'
    },
    subCategory: {
        textTransform: 'capitalize',
        marginLeft: 0,
    },
    textLabel: {
        position: 'absolute',
        top: '-20px',
        background: '#fff',
        padding: '0 3px',
        fontSize: '10px',
    },
    outline: {
        marginBottom: '20px',
    },
    main: {
        padding: '20px',
        minWidth: '220px'
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '20px',
    },
    category: {
        fontWeight: 'bold',
        textTransform: 'capitalize',
        marginLeft: 0,
    },
    categoryTitle: {
        fontWeight: 'bold',
        textTransform: 'capitalize'
    },
    subCategoriesTitle: {
        textTransform: 'capitalize'
    },
});

export default (data, key) => {
    const classes = useStyles();
    const [init, setInit] = useState(false)
    const [segment, setSegment] = useState([])
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);

    const unSelected = () => {
        segment.forEach((category) => {
            if(category.id !== EMPTY_SEGMENT.id){
                category.active = false
                category.segments.forEach((subCategory) => {
                    subCategory.active = false
                })
            }
        })
        setSegment([...segment])
    }

    const checkEmptySelected = (id) => {
        if(id === EMPTY_SEGMENT.id) {
            unSelected()
        }else{
            const emptySegment = segment.find(({id}) => id === EMPTY_SEGMENT.id)
            if(emptySegment) emptySegment.active = false
        }
    }

    const onChange = (event, id) => {
        event.preventDefault();
        const name = event.target.name

        segment.forEach((category) => {
            if(id === category.id){
                const active = !category[name]
                category[name] = active

                category.segments.forEach((subCategory) => {
                    subCategory[name] = active
                })
            }
        })

        checkEmptySelected(id)
        setSegment([...segment])
    };

    const onChangeSubCategpries = (event, id, idSub) => {
        event.preventDefault();
        const name = event.target.name

        segment.forEach((category) => {
            if(id === category.id){
                category.segments.forEach((subCategory) => {
                    if(subCategory.id === idSub){
                        subCategory[name] = !subCategory[name]
                    }
                })
            }
        })

        checkEmptySelected(id)
        setSegment([...segment])
    };

    useEffect(() => {
        const loadSegment = async () => {
            try {
                setLoading(true);
                setErrorMessage(null);

                const [segment] = await get()

                segment.forEach((target) => {
                    target.active = false
                    target.segments.forEach((segment) => segment.active = false)
                })


                if(data.value.length){
                    // if(typeof data.value === 'string') data.value = data.value.split(',')

                    data.value.forEach((name) => {
                        segment.forEach((target) => {
                            target.segments.forEach((segment) => {
                                if(name === segment.name){
                                    segment.active = true
                                }
                            })
                        })
                    })

                    segment.forEach((target) => {
                        if(target.segments.length === target.segments.filter(({active}) => active).length){
                            target.active = true
                        }
                    })
                }

                setInit(true)

                if(data.empty){
                    setSegment([EMPTY_SEGMENT, ...segment])
                    setLoading(false);

                    return ;
                }

                setSegment(segment)
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        loadSegment()
    }, [setErrorMessage, setLoading])

    useEffect(() => {
        if(init){
            const parseSegment = (segment) => {
                return segment.map((category) => category.segments.filter((data) => data.active).map(({name}) => name)).flat().filter((data) => typeof data !== 'undefined')
            }

            let value = parseSegment(segment)

            if(segment.find(({id}) => id === EMPTY_SEGMENT.id)?.active){
                value.push(EMPTY_SEGMENT.name)
            }

            data.onCallback({
                target:{
                    name: data.name,
                    value: value
                }
            })
        }

    }, [segment, init, data])

    return (
        <PopupState variant="popover" popupId="segment" key={key}>
            {(popupState) => (
                <Box key={'popup-segment'} className={classes.body}>
                    <InputLabel className={classes.textLabel} htmlFor="segment" variant="filled">
                        Segment
                    </InputLabel>
                    <OutlinedInput
                        id={'segment'}
                        label={'Segments'}
                        fullWidth
                        value={data.value}
                        endAdornment={<InputAdornment position="end"><Button
                            {...bindTrigger(popupState)}
                            variant="text">Choose</Button></InputAdornment>}
                    />
                    <Popover
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <FormGroup className={classes.main}>
                            <Typography className={classes.title} fontSize={14} component="h3">Choose segment</Typography>
                            {segment.length && segment.map((category, ind) => (
                                <Box key={'segment' + ind} className={classes.outline}>
                                    <FormControlLabel
                                        classes={classes}
                                        labelPlacement="start"
                                        key={category.id}
                                        className={classes.category}
                                        control={<Checkbox name='active' checked={category.active} />}
                                        onClick={(e) => onChange(e, category.id)}
                                        label={<Typography className={classes.categoryTitle} fontSize={14} variant="h6"><EllipsisText text={category.name} length={20} /></Typography>}
                                    />
                                    {category.segments.map(({id, active, name}) => (
                                        <FormControlLabel
                                            classes={classes}
                                            key={id}
                                            labelPlacement="start"
                                            label={<Typography className={classes.subCategoriesTitle} fontSize={14} variant="h6"><EllipsisText text={name} length={20} /></Typography>}
                                            className={classes.subCategory}
                                            control={<Checkbox name='active' checked={active} />}
                                            checked={active}
                                            onClick={(e) => onChangeSubCategpries(e, category.id, id)} />
                                    ))}
                                </Box>
                            ))}

                            {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
                        </FormGroup>
                    </Popover>
                </Box>
            )}
        </PopupState>
    );
}